exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modale-background{z-index:998;position:fixed;left:0;top:0;height:100%;width:100%;background-color:rgba(0,0,0,.5)}.modale{border-radius:15px;background-color:#fff;box-shadow:inset 0 0 35px 5px rgba(0,0,0,.25),inset 0 2px 1px 1px hsla(0,0%,100%,.5),inset 0 -2px 1px 0 rgba(46,15,15,.25);padding:15px;position:fixed;left:50%;top:50%;transform:translate(-50%,-50%);z-index:999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-232fb7d3","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Modale.vue
// module id = 22
// module chunks = 0